<div class="app-modal-title">Exception</div>
<div class="app-modal-content">
	<!-- <div class="exception-header">
		<div class="check-cell"></div>
		<div class="col-cell">Field</div>
		<div class="val-cell">Value</div>
		<div class="desc-cell">Description</div>
		<div class="reason-cell">Reason</div>
	</div> -->

	<div class="exceptions-list">
		<div *ngFor="let exc of exceptions; let idx = index;" class="exception-item">
			<div class="operations">
				<input name="added-{{idx}}" type="checkbox" [(ngModel)]="exc.isChecked">
			</div>
			<div class="attribute-list">
				<ng-container *ngFor="let attr of attributes; let idx2 = index;">
					<div *ngIf="!(attr.prop==='value'&&exc.colName===qaNotesGeomColName)" class="attribute-row">
						<div class="column-cell">
							{{attr.name}}
						</div>
						<div class="value-cell" title="{{exc[attr.prop]}}">
							<div *ngIf="!attr.enabled">{{exc[attr.prop]}}</div>
							<textarea *ngIf="attr.enabled" name="val-{{idx}} - {{idx2}}" disabled="{{!attr.enabled}}" required="{{attr.enabled && exc.isChecked}}" [(ngModel)]="exc[attr.prop]"></textarea>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" md-raised-button (click)="cancel()">Cancel</button>
		<button class="button-general" md-raised-button [disabled]="disableAdd()" (click)="add()">Add</button>
	</div>
</div>
